<script setup lang="ts">
const siteUrl = useSiteUrl()
</script>

<template>
    <!-- footer -->
    <footer class="w-full bg-surface lg:border-t border-border py-8 px-6 lg:px-24">
        <BaseContainer class="w-full">
            <div class="w-full flex flex-col lg:flex-row justify-between gap-6 lg:gap-8">
                <div class="w-full flex flex-col-reverse lg:flex-row gap-6 lg:gap-8">
                    <div class="flex flex-col justify-between gap-3 items-start">
                        <div class="flex flex-col gap-3 items-start">
                            <NuxtLink to="/">
                                <img src="/home/img/home/Logo2.svg" alt="لوگوی پی‌جیب">
                            </NuxtLink>

                            <p class="font-bold text-justify lg:text-start leading-6 text-sm text-muted">
                                در پی‌جیب می‌توانید مبلغ مورد نظرتان را به سرعت و<br class="hidden lg:block">
                                با کم‌ترین کارمزد، از ایران به اروپا،
                                استراليا، كانادا و<br class="hidden lg:block">
                                تركيه یا بالعکس، با کمک سایر کاربران
                                پی‌جیب،<br class="hidden lg:block">
                                انتقال دهید.
                            </p>
                        </div>

                        <div class="flex items-center text-xs text-muted gap-1">
                            <img src="/home/img/home/Group.svg" alt="حقوق محفوظ است">
                            <p>کلیه حقوق برای پی جیب محفوظ است.</p>
                        </div>
                    </div>

                    <div class="flex gap-8">
                        <ul class="hidden lg:flex flex-col gap-2 items-start">
                            <li>
                                <NuxtLink to="/terms" class="text-sm font-bold text-muted">
                                    <span class="text-muted text-sm">
                                        قوانین و مقررات
                                    </span>
                                </NuxtLink>
                            </li>

                            <li>
                                <a :href="siteUrl('/blog/')" class="text-sm font-bold text-muted">
                                    <span class="text-muted text-sm">
                                        وبلاگ
                                    </span>
                                </a>
                            </li>

                            <li>
                                <NuxtLink to="/contact-us/" class="text-sm font-bold text-muted">
                                    <span class="text-muted text-sm">
                                        تماس با ما
                                    </span>
                                </NuxtLink>
                            </li>

                            <li>
                                <NuxtLink to="/about/" class="text-sm font-bold text-muted">
                                    <span class="text-muted text-sm">
                                        درباره ما
                                    </span>
                                </NuxtLink>
                            </li>
                        </ul>

                        <div class="grid grid-cols-2 lg:flex flex-row lg:flex-col items-start gap-3">
                            <div class="flex flex-col items-start gap-3">
                                <div class="text-sm font-bold text-muted mb-0.5">
                                    تماس با پی‌جیب
                                </div>

                                <a id="btn-mail" href="mailto:info@payjib.com"
                                    class="flex items-center gap-1 text-sm font-bold text-muted">
                                    <img src="/home/img/home/sms.svg" alt="" aria-hidden="true">
                                    <span class="text-muted text-sm">
                                        info@payjib.com
                                    </span>
                                </a>

                                <div class="flex items-start lg:items-center gap-1 text-sm font-bold text-muted">
                                    <img src="/home/img/home/Telegram3.svg" alt="" aria-hidden="true">

                                    <div
                                        class="flex flex-col lg:flex-row items-center gap-1 lg:gap-2 text-muted text-sm font-bold">
                                        <a id="btn-telegram1" href="https://t.me/+989360950650"
                                            aria-label="تماس با پشتیبانی پی‌جیب در تلگرام با شماره ۰۹۳۶۰۹۵۰۶۵۰"
                                            class="ltr">
                                            +98 9360950650
                                        </a>

                                        <span class="hidden lg:block">-</span>

                                        <a id="btn-telegram2" href="https://t.me/+989356049661"
                                            aria-label="تماس با پشتیبانی پی‌جیب در تلگرام با شماره ۰۹۳۵۶۰۴۹۶۶۱"
                                            class="ltr">
                                            +98 9356049661
                                        </a>
                                    </div>
                                </div>

                                <div class="flex items-start lg:items-center gap-1 text-sm font-bold text-muted">
                                    <img src="/home/img/home/whatsapp.svg" alt="" aria-hidden="true">

                                    <div
                                        class="flex flex-col lg:flex-row items-center gap-1 lg:gap-2 text-muted text-sm font-bold">
                                        <a id="btn-whatsapp1" href="https://wa.me/989360950650"
                                            aria-label="تماس با پشتیبانی پی‌جیب در واتساپ با شماره ۰۹۳۶۰۹۵۰۶۵۰"
                                            class="ltr">
                                            +98 9360950650
                                        </a>

                                        <span class="hidden lg:block">-</span>

                                        <a id="btn-whatsapp2" href="https://wa.me/989356049661"
                                            aria-label="تماس با پشتیبانی پی‌جیب در واتساپ با شماره ۰۹۳۵۶۰۴۹۶۶۱"
                                            class="ltr">
                                            +98 9356049661
                                        </a>
                                    </div>
                                </div>
                            </div>

                            <div class="flex flex-col items-start gap-3 mt-8 lg:mt-0">
                                <div class="flex items-center gap-1 text-sm font-bold text-muted">
                                    <img src="/home/img/home/call.svg" alt="" aria-hidden="true">

                                    <div class="flex items-center gap-2 text-muted text-sm font-bold">
                                        <a id="btn-tel" href="tel:02122632790"
                                            aria-label="تماس تلفنی با پشتیبانی پی‌جیب با شماره ۰۲۱۲۲۶۳۲۷۹۰" class="ltr">
                                            0 21 2263 2790
                                        </a>
                                    </div>
                                </div>

                                <div class="flex items-start gap-1 text-sm font-bold text-muted">
                                    <img src="/home/img/home/location3.svg" alt="" aria-hidden="true">

                                    <address class="text-justify flex items-center gap-2 text-muted text-sm font-bold">
                                        استان : تهران - شهرستان : تهران - بخش : مرکزی - شهر : تهران - محله<br
                                            class="hidden lg:block">
                                        : حسن آباد
                                        -
                                        زرگنده - خیابان شهید سیامک شکرآبی - خیابان امام زاده -<br
                                            class="hidden lg:block">
                                        پلاک : ۱۸ - طبقه
                                        :۲
                                    </address>
                                </div>
                            </div>
                        </div>
                    </div>

                    <ul class="flex gap-2 flex-col lg:hidden items-start">
                        <li>
                            <NuxtLink to="/terms" class="text-sm font-bold text-muted">
                                <span class="text-muted text-sm">
                                    قوانین و مقررات
                                </span>
                            </NuxtLink>
                        </li>

                        <li>
                            <a :href="siteUrl('/blog/')" class="text-sm font-bold text-muted">
                                <span class="text-muted text-sm">
                                    وبلاگ
                                </span>
                            </a>
                        </li>

                        <li>
                            <NuxtLink to="/contact-us/" class="text-sm font-bold text-muted">
                                <span class="text-muted text-sm">
                                    تماس با ما
                                </span>
                            </NuxtLink>
                        </li>

                        <li>
                            <NuxtLink to="/about/" class="text-sm font-bold text-muted">
                                <span class="text-muted text-sm">
                                    درباره ما
                                </span>
                            </NuxtLink>
                        </li>
                    </ul>
                </div>
                <div class="">
                    <a referrerpolicy='origin' target='_blank' href='https://trustseal.enamad.ir/?id=609124&Code=lvXgGFcJrtROzjxwsLye02tmeTgO9fRq'><img referrerpolicy='origin' src='https://trustseal.enamad.ir/logo.aspx?id=609124&Code=lvXgGFcJrtROzjxwsLye02tmeTgO9fRq' alt='' style='cursor:pointer' code='lvXgGFcJrtROzjxwsLye02tmeTgO9fRq'></a>
                </div>
            </div>
        </BaseContainer>
    </footer>
</template>

<script>
</script>
